module.exports = __webpack_public_path__ + "static/images/404.d54552f39d995f91cda31e7e8e2bde72.svg";